var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeasurement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#111111;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.3,9.4L9.4,43.3l11.3,11.3l33.9-33.9L43.3,9.4z M15,43.3l2.8-2.8l2.8,2.8l1.4-1.4l-2.8-2.8l2.8-2.8l2.8,2.8 l1.4-1.4l-2.8-2.8l2.8-2.8l2.8,2.8l1.4-1.4l-2.8-2.8l2.8-2.8l2.8,2.8l1.4-1.4L32,26.3l2.8-2.8l2.8,2.8l1.4-1.4l-2.8-2.8l2.8-2.8 l2.8,2.8l1.4-1.4l-2.8-2.8l2.8-2.8l5.7,5.7L20.7,49L15,43.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 64,
    height: 64
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurement);
export default __webpack_public_path__ + "static/media/Measurement.4c687ea0369ca0e1de0083e6bbc362f9.svg";
export { ForwardRef as ReactComponent };